import { type MultiLineTextField } from '../../../types/graphql.form.ts'
import { type InputProps } from './index.tsx'

export default function TextareaMultiLineText({ field }: InputProps) {
	const multi = field as MultiLineTextField
	return (
		<div className="full">
			<textarea
				name={multi.handle}
				id={multi.uid}
				required={multi.required}
				minLength={multi.multilineMin}
				maxLength={multi.multilineMax}
				className="w-full"
				placeholder={field.name}
			></textarea>
		</div>
	)
}
